'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = exports.cartPopup = undefined;

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _dom = require('../common/dom.js');

var _dom2 = _interopRequireDefault(_dom);

var _themeCurrency = require('@shopify/theme-currency');

var currency = _interopRequireWildcard(_themeCurrency);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var shopCurrency = (0, _jquery2.default)('body').attr('data-shop-currency');

var cartPopup = exports.cartPopup = function cartPopup(item, meta, dimensions) {
  //Display the item
  _dom2.default.$siteOverlay.addClass('is-active');
  var $cartPopup = (0, _jquery2.default)(_dom2.default.cartPopup);
  $cartPopup.addClass('is-active');

  if ((0, _jquery2.default)(window).width() < 1024) {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  //Show the correct information
  var image = item.image.replace('.png', '_192x.png').replace('.jpg', '_192x.jpg');
  var title = item.product_title;
  var price = currency.formatMoney(item.final_price, "${{amount}} " + shopCurrency);

  if (item.properties != null) {
    if ("_custom_finish_price" in item.properties) {
      price = item.properties['_custom_finish_price'];
    }

    if ("_custom_finish" in item.properties) {
      (0, _jquery2.default)(_dom2.default.cartPopupFinish).html('<span>Custom Finish: </span>' + item.properties['_custom_finish']);
    }

    if ("_custom_finish_addon" in item.properties) {
      (0, _jquery2.default)(_dom2.default.cartPopupFinish).append(', ' + item.properties['_custom_finish_addon']);
    }

    if ("_custom_finish_dry_mounted" in item.properties) {
      (0, _jquery2.default)(_dom2.default.cartPopupFinish).append(', Dry Mounted');
    }
  }

  (0, _jquery2.default)(_dom2.default.cartPopupImage).html('<img src="' + image + '" alt="' + title + '">');
  (0, _jquery2.default)(_dom2.default.cartPopupTitle).html(title);
  (0, _jquery2.default)(_dom2.default.cartPopupPrice).html(price);
  (0, _jquery2.default)(_dom2.default.cartPopupTags).html(meta);

  if (dimensions == '') {
    if (item.properties != null) {
      if ("Frame width" in item.properties) {
        dimensions = item.properties['Frame width'] + ' &times; ';
      }

      if ("Frame height" in item.properties) {
        dimensions += item.properties['Frame height'];
      }
    }
  }

  (0, _jquery2.default)(_dom2.default.cartPopupDimensions).html(dimensions);
};

var init = exports.init = function init() {
  bindUIActions();
};

var bindUIActions = function bindUIActions() {
  (0, _jquery2.default)(_dom2.default.cartPopupCloseTrigger).on('click', function (e) {
    _dom2.default.$siteOverlay.click();
  });

  (0, _jquery2.default)(_dom2.default.cartPopupLink).on('click', function (e) {
    _dom2.default.$siteOverlay.click();
  });

  _dom2.default.$siteOverlay.on('click', function (event) {
    (0, _jquery2.default)(_dom2.default.cartPopup).removeClass('is-active');

    //Reset Content
    (0, _jquery2.default)(_dom2.default.cartPopupFinish).html('');
    (0, _jquery2.default)(_dom2.default.cartPopupImage).html('');
    (0, _jquery2.default)(_dom2.default.cartPopupTitle).html('');
    (0, _jquery2.default)(_dom2.default.cartPopupPrice).html('');
    (0, _jquery2.default)(_dom2.default.cartPopupTags).html('');
    (0, _jquery2.default)(_dom2.default.cartPopupDimensions).html('');
  });
};